import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DriverOnboardingListState } from './driver-onboarding-list.reducer';

export const driverOnboardingListState = createFeatureSelector<DriverOnboardingListState>('driverOnboardingList');

export const getTransitPrograms = createSelector(driverOnboardingListState, (state: DriverOnboardingListState) => state.transitPrograms);

export const getSelectedTransitPrograms = createSelector(
  driverOnboardingListState,
  (state: DriverOnboardingListState) => state.selectedTransitPrograms
);

export const getFilteredTransitProgramChips = createSelector(
  driverOnboardingListState,
  (state: DriverOnboardingListState) => state.transitProgramChips
);

export const getFilteredDriverStatusChips = createSelector(
  driverOnboardingListState,
  (state: DriverOnboardingListState) => state.driverStatusChips
);

export const getFilteredSearchString = createSelector(
  driverOnboardingListState,
  (state: DriverOnboardingListState) => state.filteredSearchString
);

export const getSelectedState = createSelector(driverOnboardingListState, (state: DriverOnboardingListState) => state.selectedStateCode);

export const getIsReviewResult = createSelector(driverOnboardingListState, (state: DriverOnboardingListState) => state.isReviewResult);

export const getSearchString = createSelector(driverOnboardingListState, (state: DriverOnboardingListState) => state.searchString);

export const getPageNumber = createSelector(driverOnboardingListState, (state: DriverOnboardingListState) => state.pageNumber);

export const getPageSize = createSelector(driverOnboardingListState, (state: DriverOnboardingListState) => state.pageSize);

export const getDrivers = createSelector(driverOnboardingListState, (state: DriverOnboardingListState) => state.drivers);

export const getTotalCount = createSelector(driverOnboardingListState, state => state.totalCount);

export const getLoading = createSelector(driverOnboardingListState, (state: DriverOnboardingListState) => state.loading);

export const getApprovalMode = createSelector(driverOnboardingListState, state => state.approvalMode);
